import Navbar from "../Navbar";
import Tranasctions from "../Tranasctions";

import { MdOutlineCurrencyRupee } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import './index.css'
import { useState } from "react";

const WebPAge = () => {
    const [sidebar, setSideBar] = useState(false)
    return (
        <div className="bg-container">
            <div className="side-bar-container">
            <div className="bar-contianer">
                <div className="image-name-container">
                    <div className="container-1">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704778516/assign_ynpwcp.png"
                            alt="image" className="logo-image"
                        />
                        <div className="container-2">
                            <span className="name-heading">Nishyan</span>
                            <span className="store-line">Visit store</span>
                        </div>
                    </div>
                    <button className="arrow-button" onClick={() => setSideBar(true)}>
                        <IoIosArrowDown className="icon-11" />
                    </button>
                </div>
                <ul className="menu-container">
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781146/icon-2_ygwn3e.svg" className="icon-1"/>
                        <span className="item">Home</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781147/icon3_aq1wh6.svg" className="icon-1"/>
                        <span className="item">Orders</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704780875/icon-1_etc9nc.svg"
                        className="icon-1" />
                        <span className="item">Products</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781365/icon4_buqidz.svg"
                        className="icon-1" />
                        <span className="item">Delivery</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781366/icon-5_dvnxny.svg"
                        className="icon-1" />
                        <span className="item">marketing</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781367/icon-6_ddws9j.svg"
                        className="icon-1" />
                        <span className="item">Analytics</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781367/icon-7_f5dqoz.svg"
                        className="icon-1" />
                        <span className="item">Payments</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781368/icon-8_gdfvvu.svg"
                        className="icon-1" />
                        <span className="item">Tools</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781368/icon-9_fwppuh.svg"
                        className="icon-1" />
                        <span className="item">Discounts</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781473/icon-10_avcby6.svg"
                        className="icon-1" />
                        <span className="item">Audience</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781474/icon-11_sxjoku.svg"
                        className="icon-1" />
                        <span className="item">Appearance</span>
                    </li>
                    <li className="menu-items">
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704781474/icon-12_hrwk1y.svg"
                        className="icon-1" />
                        <span className="item">Plugins</span>
                    </li>
                </ul>
                </div>
                <div className="credit-container">
                    <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704792580/icon_30_o4zrui.svg" className="credit-image" />
                    <div className="credit-box">
                        <span className="credit">Available credit</span>
                        <span className="credit-score">222.10</span>
                    </div>
                </div>
            </div>
            <div className="main-container">
            <Navbar />
            <div className="overview-container">
                <p className="overview-heading">Overview</p>
                <select id="status" className="form-container">
                    <option value="Last Month" className="option">Last Month</option>
                    <option value="Present" className="option">Present</option>
                </select>
            </div>
            <div className="orders-amounts-container">
                <div className="orders-container">
                    <p className="order-name">Online orders</p>
                    <h1 className="orders-count">231</h1>
                </div>
                <div className="orders-container">
                    <p className="order-name">Amount recieved</p>
                    <h1 className="orders-count"><MdOutlineCurrencyRupee />23,92,312.19</h1>
                </div>
            </div>
            <p className="transactions-para">Transactions | This Month</p>
            <Tranasctions />
            </div>
            
        </div>
    )
}

export default WebPAge